import { Outlet } from "react-router-dom";

const CustomLibrary = () => {
  return (
    <div>
      {/* <h2>Custom Library</h2> */}
      <Outlet />
    </div>
  );
};

export default CustomLibrary;